import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'precio-plan-servicio/'; // Ruta relativa (Django ya tiene /api/ en baseURL)

export interface PrecioPlanServicio {
    id: number;
    servicio: number;
    servicio_nombre: string; // <- agregado
    plan_duracion_config: number;       // configuracion de duración asociada
    plan_nombre: string;      // <- agregado
    precio_inicial: number;
    precio_posterior: number | null;
    duracion_inicial: number | null;
    fecha_creacion: string;
    estado: boolean;
    usar_contador: boolean; 
}


// GET: Obtener todos los precios de los planes de servicio
export const fetchPrecioPlanesServicios = async (): Promise<PrecioPlanServicio[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<PrecioPlanServicio[]>(API_URL);
        return response.data;
    });
};

// POST: Crear un nuevo precio de plan de servicio
export const createPrecioPlanServicio = async (data: {
    servicio: number;
    plan_duracion_config: number;
    precio_inicial: number;
    precio_posterior?: number | null;
    duracion_inicial?: number | null;
    estado?: boolean;
    usar_contador?: boolean;
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar un precio de plan de servicio existente
export const updatePrecioPlanServicio = async (
    id: number,
    data: {
        servicio: number;
        plan_duracion_config: number;
        precio_inicial: number;
        precio_posterior?: number | null;
        duracion_inicial?: number | null;
        estado?: boolean;
        usar_contador?: boolean;
    }
) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar un precio de plan de servicio
export const deletePrecioPlanServicio = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};
